import { ApiProperty } from "@nestjs/swagger"

export class DeviceNameDto {
    @ApiProperty()
    deviceName?:string
    @ApiProperty()
    deviceMacId?:string
}